var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEllipse200(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 187,
    viewBox: "0 0 87 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.8537 49.5548C69.8537 101.574 100.895 187 62.3155 187C23.7364 187 0 146.226 0 94.2071C0 42.1884 31.2746 0.0188514 69.8537 0.0188514C108.433 0.0188514 69.8537 -2.46389 69.8537 49.5548Z",
    fill: "#FFA412"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse200);
export default __webpack_public_path__ + "static/media/Ellipse 200.9740f318cfb2c6d4e3849595db412fc6.svg";
export { ForwardRef as ReactComponent };